import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

const StyledCartSection = styled.section`
  --image-column-width: 124px;
  --text-column-width: 30vw;
  --card-horizontal-padding: ${legacyTheme.spacing.s24};
  --card-grid-column-gap: ${legacyTheme.spacing.s24};

  width: 100%;
  grid-column-start: 1;
  display: flex;
  justify-self: center;
  flex-direction: column;
  align-items: center;
  padding: ${legacyTheme.props.verticalSpacingMob} ${legacyTheme.props.minimumBlockPadding} 0;

  ${props =>
    props.optional &&
    `
  background-color: ${theme.colors.neutral[300]};
  padding: ${`${legacyTheme.props.verticalSpacingMob} ${legacyTheme.props.minimumBlockPadding}`};
  `}

  ${legacyTheme.breakpoints.match('md')} {
    --image-column-width: 84px;
    --text-column-width: auto;
    width: 100%;
  }

  ${legacyTheme.breakpoints.match('sm')} {
    padding-top: ${legacyTheme.spacing.s40};
    ${props => (props.optional ? `padding-bottom: ${legacyTheme.spacing.s40};` : '')}
  }
`;

export default StyledCartSection;
